import React, {useContext, useState} from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoSrc from '../../../images/logo-full.svg';
import logoSrcReduced from '../../../images/logo-minimize-black.svg';
import MainNav from './MainNav/MainNav';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {useBreakpoint} from '../../../libs/breakpoint';
import {
    faSearch,
    faBell,
    faSquareDashedCirclePlus,
    faPaperPlane
} from "@fortawesome/pro-regular-svg-icons";

import "./AppHeader.scss";
// import { useAbility } from '../../../ability-context';
import {useQuery} from '@tanstack/react-query';
import {
    fetchCountMessenger, fetchUnreadNotifications,
    USER_CURRENT_COUNT_MESSENGER_KEY,
    USER_UNREAD_NOTIFICATIONS_KEY,
} from '../../../api/public-voissa/users';
import createLink from '../../../libs/createLink';
import SideView from '../SideView/SideView';

import classNames from 'classnames';
import NotificationsList from '../NotificationsList/NotificationsList';
import Drawer from "../Drawer/Drawer";
import Uploads from "../../components/upload/Uploads";
import Menu from '../Menu/Menu';
import Container from '../UI/Container/Container';
import {useSocketNotifications, useSocketVMessengerNotifications} from "../../../hooks/useSocket";
import { ModalContext } from '../ModalManager';
import { moreThanMaxValue } from '../../../libs/helper';
import useRestriction from '../../../hooks/useRestriction';
import CONTENT_RESTRICTION_RULE from '../../../const/contentRestrictionRule';
import useCurrentUser from '../../../hooks/useCurrentUser';


const AppHeaderConnected = ({openNotifications, toggleNotifications}) => {
    const location = useLocation();
    const [toggleUpload, setToggleUpload] = useState(false);
    const currentUser = useCurrentUser();
    const restriction = useRestriction(CONTENT_RESTRICTION_RULE.CREATE_PUBLICATION_MEDIA);

    const {data : dataUnReadRoom} = useQuery(
        [USER_CURRENT_COUNT_MESSENGER_KEY],
        ()=> fetchCountMessenger(),
        {
            staleTime : (1000 * 60 * 2),
            enabled : !!currentUser,
            placeholderData : {total : 0},
            refetchOnWindowFocus: true
        }
    );

    const {data : dataUnReadNotifications} = useQuery(
        [USER_UNREAD_NOTIFICATIONS_KEY],
        ()=> fetchUnreadNotifications(),
        {
            staleTime : (1000 * 60 * 2),
            enabled : !!currentUser,
            placeholderData : {total : 0},
            refetchOnWindowFocus: true
        }
    );

    useSocketVMessengerNotifications();
    useSocketNotifications();

    let totalVMeesenger = dataUnReadRoom?.total || 0;

    return (
        <div className="app-header-actions">
            <div className="app-header-action-button action-button-publish" onClick={restriction.isRestricted ? ()=> restriction.restrictionHandler() : () => setToggleUpload(true)}>
                <FontAwesomeIcon icon={faSquareDashedCirclePlus}/> Publier
            </div>

            <Link to={createLink("recherche")} rel={"nofollow"} className="app-header-action-button">
                <FontAwesomeIcon icon={faSearch}/>
            </Link>
            <div className={classNames("app-header-action-button", {active: openNotifications})}
                 onClick={() => toggleNotifications()}>
                <FontAwesomeIcon icon={faBell}/>
                {dataUnReadNotifications?.total >= 1 && <div
                    className="app-header-action-button-count">{moreThanMaxValue(dataUnReadNotifications?.total)}</div>}
            </div>
            <Link className="app-header-action-button" to={createLink("vMessenger")} state={{from: location.pathname}}>
                <FontAwesomeIcon icon={faPaperPlane}/>{totalVMeesenger >= 1 &&
                <div className="app-header-action-button-count">{moreThanMaxValue(totalVMeesenger)}</div>}
            </Link>

            <Drawer
                open={toggleUpload}
                handleClose={() => setToggleUpload(false)}
                headContent={`Nouvelle publication`}
            >
                <Uploads handleClose={() => setToggleUpload(false)}/>
            </Drawer>
        </div>
    );
};

const AppHeaderDisconnected = () => {
    const {openModal} = useContext(ModalContext);
    return (
        <div className="app-header-actions">
            <Link onClick={() => openModal('Signin', {lockedAction : 'SEARCH_MEMBERS'})} rel={"nofollow"} className="app-header-action-button">
                <FontAwesomeIcon icon={faSearch} />
            </Link>
            <span to={createLink("signin")} onClick={()=>openModal('Signin')} rel={"nofollow"} className="app-header-action-button action-button-publish">
                Connexion/Inscription
            </span>
        </div>
    );
}

const AppHeader = ({hasAcceptedDisclaimer, currentUser}) => {
    const breakpoints = useBreakpoint();
    const navigate = useNavigate();
    const location = useLocation();
    const [openNotifications, setOpenNotifications] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    const toggleNotifications = () => {
        if(breakpoints.sm) navigate("/notifications");
        else setOpenNotifications(!openNotifications);
    };
    const toggleMenu = (e) => {
        if(!breakpoints.sm){
            e.preventDefault();
            setOpenMenu(!openMenu);
        }
    };
    const chatWebcamDisableNav = (location?.pathname === '/chat-webcams') && breakpoints.md;
    return hasAcceptedDisclaimer ? (
        <header id='app-header'>
            <SideView className="app-header-notifications" open={openNotifications} handleClose={()=>setOpenNotifications(false)} headContent="Notifications">
                <NotificationsList style={{padding:"8px"}}/>
            </SideView>
            <SideView open={openMenu} handleClose={()=>setOpenMenu(false)} headContent="Menu">
                <Menu style={{padding:'10px'}}/>
            </SideView>
            <Container className="app-header-wrapper" hasPadding>
                <Link className='app-header-logo' to="" title={"Voissa"} rel="nofollow noopener noreferrer" >
                    <img src={(breakpoints.sm && currentUser) ? logoSrcReduced : logoSrc} alt="Voissa" style={!!process.env.REACT_APP_GHOST_MODE ? {opacity:0} : {}}/>
                </Link>
                {!chatWebcamDisableNav && <MainNav currentUser={currentUser} openMenu={openMenu} toggleMenu={toggleMenu}/>}
                {currentUser ? <AppHeaderConnected openNotifications={openNotifications} toggleNotifications={toggleNotifications}/> : <AppHeaderDisconnected />}
            </Container>
        </header>
    ) : (
         <header id='app-header'>
            <Container className="app-header-wrapper" hasPadding>
                <Link className='app-header-logo' to="" title={"Voissa"} rel="nofollow noopener noreferrer" >
                    <img src={(breakpoints.sm && currentUser) ? logoSrcReduced : logoSrc} alt="Voissa" style={!!process.env.REACT_APP_GHOST_MODE ? {opacity:0} : {}}/>
                </Link>
            </Container>
         </header>
    );
}
export default React.memo(AppHeader);